
import Vue, { CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class SeoHeader extends Vue {
	@Prop({
	    type: Boolean,
	    default: true
	})
	isH1!: boolean;

	render(h: CreateElement) {
	    const data = {
	        ...this.$props,
	        class: {
	            h1: this.isH1,
	            h2: !this.isH1
	        }
	    };
	    return h(this.isH1 ? 'h1' : 'h2', data, this.$slots.default);
	}
}
